import React, { useState } from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import ValidatedInput from "./ValidatedInput";
const LabelWrapper = styled.span`
  display: flex;
  align-items: center;
`;
const ToggleMask = styled.button`
  border: 0;
  background: none;
  padding: 0;
  margin: 0 0 0 12px;
`;
const MaskedInput = ({ className = void 0, label, ...props }) => {
  const [masked, setMasked] = useState(true);
  const toggleLabel = /* @__PURE__ */ React.createElement(LabelWrapper, null, label, /* @__PURE__ */ React.createElement(ToggleMask, { onClick: () => setMasked(!masked), "aria-description": `Toggle ${label} field input` }, /* @__PURE__ */ React.createElement(Icon, { name: masked ? "visibility_off" : "visibility" })));
  return /* @__PURE__ */ React.createElement(ValidatedInput, { ...props, type: masked ? "password" : "text", label: toggleLabel, formGroupClassName: className });
};
export default MaskedInput;
